/**
 * CONFIGURATION file to deploy the correct variables for each environment
 * new environment can be added to the scripts to the package.json file
 * for example:
 *   'start': 'REACT_APP_STAGE=local npm-run-all -p watch-css start-js',
 *   'build': 'npm run build-css && react-scripts build',
 *   'build-dev': 'REACT_APP_STAGE=dev react-scripts build',
 *   'build-prod': 'REACT_APP_STAGE=prod react-scripts build',
 *   'build-qa': 'REACT_APP_STAGE=qa react-scripts build',
 *
 * The common constant will have the common variables between the environments
 */

/**
 * The variables to use in ENV environment when is run locally
 */
const local = {
    API_URL: 'https://mobileapistag.fpc.com.au/api/',
    SUGAR_API: 'https://crmstag.fpc.com.au/rest/v11_20/',
    AWS_XERO_API: 'https://31ldzdtjib.execute-api.ap-southeast-2.amazonaws.com/develop/',
    PUSHER: {
        presence_endpoint: 'http://localhost/pusher/auth',
        key: '69fdb012245c69545557',
        cluster: 'ap4',
    }
};

/**
 * The variables to use in ENV environment
 */
const dev = {
    API_URL: 'https://mobileapistag.fpc.com.au/api/',
    SUGAR_API: 'https://crmstag.fpc.com.au/rest/v11_20/',
    AWS_XERO_API: 'https://31ldzdtjib.execute-api.ap-southeast-2.amazonaws.com/develop/',
    ATATUS: {
        KEY: '7edac3e78e6741479400e679a0631708',
    },
    PUSHER: {
        presence_endpoint: 'https://mobileapistag.fpc.com.au/pusher/auth',
        key: '30ce788c9ece04710f97',
        cluster: 'ap4',
    }   
};

/**
 * The variables to use in UAT environment
 */
const uat = {
    API_URL: 'https://mobileapiuat.fpc.com.au/api/',
    SUGAR_API: 'https://crmuat.fpc.com.au/rest/v11_20/',
    AWS_XERO_API: 'https://31ldzdtjib.execute-api.ap-southeast-2.amazonaws.com/develop/',
    ATATUS: {
        KEY: '2997f4d9a45c4dfc8fd7651f2964a8f4',
    },
    PUSHER: {
        presence_endpoint: 'https://mobileapiuat.fpc.com.au/pusher/auth',
        key: '30ce788c9ece04710f97',
        cluster: 'ap4',
    }   
};

/**
 * The variables to use in PROD environment
 */
const prod = {
    API_URL: 'https://mobileapiprod.fpc.com.au/api/',
    SUGAR_API: 'https://crmprod.fpc.com.au/rest/v11_20/',
    AWS_XERO_API: 'https://31ldzdtjib.execute-api.ap-southeast-2.amazonaws.com/develop/',
    ATATUS: {
        KEY: 'b84d79995af1469cbcae3a1f23028aa6',
    },
    PUSHER: {
        presence_endpoint: 'https://mobileapiprod.fpc.com.au/pusher/auth',
        key: 'deed172f60b45c95bd83',
        cluster: 'ap4',
    }   
};

/**
 * The common variables to use in any environment
 */
const common = {
    BUILT_BY: 'Discovery Data',
    TOKEN: 'fpcSession',
    CLIENT_TOKEN: 'fpcClientSession',
    GUEST_TOKEN: 'fpcGuestToken',
    USERDATA: 'userData',
    BOOKING_DATA: 'booking',
    BRAND: 'WA LWD',
    GOOGLE_MAPS_KEY: 'AIzaSyCd8NpD7aC9Difw_7Wu-hU96RI5kFumqWA',
    SITE_URL: `${window.location.origin}/`,
    AWS_S3: {
        REGION: process.env.REACT_APP_AWS_REGION,
        ACCESS_KEY: process.env.ACCESS_KEY,
        SECRET_ACCESS_KEY: process.env.SECRET_ACCESS_KEY,
        XERO_DIR: 'xero/auth',
        BUCKET: 'fpc-dev-assets',
        ENGRAVING_DIR: 'engraving/images'
    },
    GUEST_USERNAME: 'discoverydata_developer',
    GUEST_PASSWORD: 'Password@1',
};

const config = () => {
    if (process.env.REACT_APP_STAGE === 'production') {
        return prod;
    } else if (process.env.REACT_APP_STAGE === 'dev') {
        return dev;
    } else if (process.env.REACT_APP_STAGE === 'uat') {
        return uat;
    }
    return local;
};

export default {
    ...common,
    ...config()
};
